import React, { RefObject } from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { useWatermarkSurface } from '../useWatermarkSurface';
import { useVideoPaused } from './useVideoPaused';
import { watermarkFileMessages as messages } from './watermarkFileMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the upsell; each part uses its own slice of it */
import styles from '../WatermarkUpsell.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ViewerWatermarkTagProps {
  /** The key of the shown file. */
  itemKey: string;
  hasWatermark: boolean;
  isVideo: boolean;
  videoRef: RefObject<HTMLVideoElement | null>;
}

/**
 * "A plan removes this": the pink tag next to the Music24 mark on the stage of the asset viewer
 * (design: trial-upsell a3 `.a-tag`). Hidden on a video while it plays, on a paid plan, for the
 * demo artist and when the licence had its clean copies already.
 */
const ViewerWatermarkTagComponent: React.FC<ViewerWatermarkTagProps> = (props) => {
  const { itemKey, hasWatermark, isVideo, videoRef } = props;
  const intl = useIntl();
  const { applies, summary } = useWatermarkSurface();
  const isPaused = useVideoPaused(videoRef, itemKey);
  // The tag is a promise for this file: only while the licence can get its clean copies (spec §14.1).
  if (!applies || !summary.cleanCopiesAvailable || !hasWatermark || (isVideo && !isPaused)) {
    return null;
  }
  return (
    <span className={styles.viewerTag} data-testid="viewer-watermark-tag">
      {intl.formatMessage(messages.viewerTag)}
    </span>
  );
};

export const ViewerWatermarkTag = TypedMemo(ViewerWatermarkTagComponent);
